import React from "react";
import LinkedinButton from "./components/linkedin-button";
import FacebookButton from "./components/facebook-button";
import LocaleStrings from "@language";
import { connect } from "react-redux";
import {
  useLocalStorage,
  LOCAL_STORAGE,
  LOGIN_SCREEN_NAME,
} from "@useLocalStorage";

function ExpressLogin({ onCompletion }) {
  const { setLocalStorage } = useLocalStorage();
  return (
    <>
      <div className="EXPRESS_CHECKOUT text-sm font-bold text-[#72788C] mb-3">
        {LocaleStrings.kExpressCheckoutText.toUpperCase()}
      </div>
      <div className="flex items-center space-x-2 mb-4">
        <LinkedinButton onCompletion={onCompletion} />
        <FacebookButton onCompletion={onCompletion} />
      </div>
      <div
        onClick={() =>
          setLocalStorage(
            LOCAL_STORAGE.LOGIN_SCREEN,
            LOGIN_SCREEN_NAME.SHARE_SCREEN
          )
        }
        className="text-sm font-medium leading-5 text-left underline decoration-solid cursor-pointer text-[#105EFB] mb-4"
      >
        {LocaleStrings.kSocialLoginSkipText}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    eventData: state.eventData,
    deviceSize: state.deviceSize,
  };
};

export default connect(mapStateToProps, {})(ExpressLogin);
